import http from '~/common/http'

export const TYPE_USERS = 1;
export const TYPE_BRANCHES = 2;
export const TYPE_ROLE= 3;

/**
 * 日期范围周数枚举代码
 */
const WEEK_SUNDAY = 0;  // 周日
const WEEK_MONDAY = 1; // 周一
const WEEK_TUESDAY = 2; // 周二
const WEEK_WEDNESDAY = 3; // 周三
const WEEK_THURSDAY = 4; // 周四
const WEEK_FRIDAY = 5; // 周五
const WEEK_SATURDAY = 6; // 周六

export const LoginRuleService = {

    getModel() {
        return {
            id: '',
            type: '',
            allow_range: [],
            allow_ips: [],
            allow_times: {}
        };
    },

    /**
     * 创建限制登录规则
     * @param loginRule
     * @returns {*}
     */
    create(loginRule) {
        return http.post('/api/login-rules/create', loginRule)
    },

    /**
     * 更新限制登录规则
     * @param loginRule
     * @returns {*}
     */
    update(loginRule) {
        return http.put('/api/login-rules/update', loginRule);
    },

    /**
     * 删除限制登录规则
     * @param id
     * @returns {*}
     */
    delete(id) {
        return http.delete('/api/login-rules/delete?id=' + id);
    },

    /**
     * 得到限制登录规则列表
     * @param params
     * @returns {*}
     */
    getList(params) {
        return http.get('/api/login-rules/index', {
            params: params
        });
    },

    /**
     * 得到指定限制登录规则详细信息
     * @param id
     * @returns {*}
     */
    getInfo(id) {
        return http.get('/api/login-rules/view?id=' + id)
    },

    getAllowTypes() {
        return {
            [TYPE_USERS]: '限制用户',
            [TYPE_BRANCHES]: '限制部门',
            [TYPE_ROLE]: '限制职位'
        };
    },

    getAllowTypeName(key) {
        let types = this.getAllowTypes();
        return types[key] ? types[key] : "";
    },

    /**
     * 获取周次列表
     * @returns {{[p: string]: string, [p: number]: string}}
     */
    getWeekTimes() {
        return {
            [WEEK_SUNDAY]: '周日',  // 周日
            [WEEK_MONDAY]: '周一', // 周一
            [WEEK_TUESDAY]: '周二', // 周二
            [WEEK_WEDNESDAY]: '周三', // 周三
            [WEEK_THURSDAY]: '周四', // 周四
            [WEEK_FRIDAY]: '周五', // 周五
            [WEEK_SATURDAY]: '周六', // 周六
        }
    },

    /**
     * 获取周次名称
     * @param key
     * @returns {*}
     */
    getWeekName(key) {
        let weekTimes = this.getWeekTimes();
        return weekTimes[key] ? weekTimes[key] : "";
    }

};


// WEBPACK FOOTER //
// ./src/services/LoginRule.js